import CheckBoxFilter from "./CheckBoxFilter";
import SelectFilter from "./SelectFilter";
import TextFilter from "./TextFilter";
export default class FitlerFactory {
    static createFilter($node) {
        if ($node.prop("tagName") === "SELECT") {
            return new SelectFilter($node);
        }
        else if ($node.prop("tagName") === "INPUT" && $node.attr("type") === "checkbox") {
            return new CheckBoxFilter($node);
        }
        else if ($node.prop("tagName") === "INPUT" && $node.attr("type") === "text") {
            return new TextFilter($node);
        }
        console.log("Unkown Filter");
        return null;
    }
}
